import {CarConditionType, SwitchType} from "../../../helpers/constants";

export const canDealerForCarCondition = ( carCondition, sellOnlyUsed ) => {
  return carCondition === CarConditionType.NEW && sellOnlyUsed === SwitchType.OFF || carCondition === CarConditionType.USED;
};
